export const PAYMENT_OPTIONS_START: string = 'PAYMENT_OPTIONS_START';
export const PAYMENT_OPTIONS_SUCCESS: string = 'PAYMENT_OPTIONS_SUCCESS';
export const PAYMENT_OPTIONS_FAIL: string = 'PAYMENT_OPTIONS_FAIL';